import { TemplatePortal, CdkPortalOutlet, ComponentPortal, PortalModule } from '@angular/cdk/portal';
import { NgStyle, DOCUMENT, isPlatformBrowser, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { inject, ChangeDetectorRef, ElementRef, Component, ChangeDetectionStrategy, Input, ViewChild, HostListener, InjectionToken, Injectable, PLATFORM_ID, DestroyRef, Injector, ViewContainerRef, NgZone, EventEmitter, TemplateRef, booleanAttribute, numberAttribute, Directive, NgModule } from '@angular/core';
import { UxaThemeClassDirective, UxaThemeModule } from '@ux-aspects-universal/angular/theming';
import { coerceCssPixelValue, coerceStringArray } from '@angular/cdk/coercion';
import { getArrowPosition } from '@ux-aspects-universal/core/popover';
import { BehaviorSubject, Subject, fromEvent, timer, combineLatest } from 'rxjs';
import { FocusMonitor } from '@angular/cdk/a11y';
import { Overlay, OverlayContainer, OverlayModule } from '@angular/cdk/overlay';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UxaDirectionality } from '@ux-aspects-universal/angular/i18n';
import { fromResizeObserver } from '@ux-aspects-universal/angular/utils';
import { tap, filter, switchMap, takeUntil, debounceTime } from 'rxjs/operators';
import { Directionality } from '@angular/cdk/bidi';
import { Platform } from '@angular/cdk/platform';
const _c0 = ["contentRef"];
const _c1 = ["arrowBackgroundRef"];
const _c2 = ["arrowForegroundRef"];
function UxaPopoverComponent_Conditional_7_ng_template_0_Template(rf, ctx) {}
function UxaPopoverComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UxaPopoverComponent_Conditional_7_ng_template_0_Template, 0, 0, "ng-template", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cdkPortalOutlet", ctx_r0.templatePortal);
  }
}
function UxaPopoverComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.content);
  }
}
function UxaFlyoutComponent_Conditional_8_ng_template_0_Template(rf, ctx) {}
function UxaFlyoutComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UxaFlyoutComponent_Conditional_8_ng_template_0_Template, 0, 0, "ng-template", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cdkPortalOutlet", ctx_r0.templatePortal);
  }
}
function UxaFlyoutComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.content);
  }
}
function UxaTooltipComponent_Conditional_7_ng_template_0_Template(rf, ctx) {}
function UxaTooltipComponent_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UxaTooltipComponent_Conditional_7_ng_template_0_Template, 0, 0, "ng-template", 7);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("cdkPortalOutlet", ctx_r0.templatePortal);
  }
}
function UxaTooltipComponent_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.content);
  }
}
const _c3 = ".uxa-popover[_ngcontent-%COMP%]{display:flex;position:relative;min-width:var(--uxa-popover__min-width);border-radius:var(--uxa-popover__border-radius);filter:var(--uxa-popover__filter);box-shadow:var(--uxa-popover__box-shadow);border:var(--uxa-popover__border-width) var(--uxa-popover__border-style) var(--uxa-popover__border-color);background-color:var(--uxa-popover__background-color);color:var(--uxa-popover__color);font-size:var(--uxa-popover__font-size);font-family:var(--uxa-popover__font-family, var(--uxa-typography__font-family));--uxa-elevation__background-color: var(--uxa-elevation__background-color--4);--uxa-elevation__box-shadow: var(--uxa-elevation__box-shadow--4);--uxa-elevation__border-color: var(--uxa-elevation__border-color--4)}.uxa-popover.uxa-light[_ngcontent-%COMP%]{--uxa-popover__color: var(--uxa-popover__color--light);--uxa-popover__background-color: var(--uxa-popover__background-color--light);--uxa-popover__border-color: var(--uxa-popover__border-color--light)}.uxa-popover.uxa-dark[_ngcontent-%COMP%]{--uxa-popover__color: var(--uxa-popover__color--dark);--uxa-popover__background-color: var(--uxa-popover__background-color--dark);--uxa-popover__border-color: var(--uxa-popover__background-color--dark)}.uxa-popover.uxa-auto-inverse[_ngcontent-%COMP%]{--uxa-popover__color: var(--uxa-popover__color--auto-inverse);--uxa-popover__background-color: var(--uxa-popover__background-color--auto-inverse);--uxa-popover__border-color: var(--uxa-popover__border-color--auto-inverse)}.uxa-popover[_ngcontent-%COMP%]   .uxa-arrow-background[_ngcontent-%COMP%], .uxa-popover[_ngcontent-%COMP%]   .uxa-arrow-foreground[_ngcontent-%COMP%]{content:\"\";position:absolute}.uxa-popover.uxa-placement-below[_ngcontent-%COMP%]{margin-block-start:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-below[_ngcontent-%COMP%]   .uxa-arrow-background[_ngcontent-%COMP%]{top:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:var(--uxa-popover-arrow__size) solid transparent;border-inline-end:var(--uxa-popover-arrow__size) solid transparent;border-bottom:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color)}.uxa-popover.uxa-placement-below[_ngcontent-%COMP%]   .uxa-arrow-foreground[_ngcontent-%COMP%]{top:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-end:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-bottom:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);transform:translateY(var(--uxa-popover__border-width))}.uxa-popover.uxa-placement-above[_ngcontent-%COMP%]{margin-block-end:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-above[_ngcontent-%COMP%]   .uxa-arrow-background[_ngcontent-%COMP%]{bottom:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:var(--uxa-popover-arrow__size) solid transparent;border-inline-end:var(--uxa-popover-arrow__size) solid transparent;border-top:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color)}.uxa-popover.uxa-placement-above[_ngcontent-%COMP%]   .uxa-arrow-foreground[_ngcontent-%COMP%]{bottom:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-end:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-top:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);transform:translateY(calc(var(--uxa-popover__border-width) * -1))}.uxa-popover.uxa-placement-before[_ngcontent-%COMP%]{margin-inline-end:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-before[_ngcontent-%COMP%]   .uxa-arrow-background[_ngcontent-%COMP%]{border-top:var(--uxa-popover-arrow__size) solid transparent;border-bottom:var(--uxa-popover-arrow__size) solid transparent;border-inline-start:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color);inset-inline-end:var(--uxa-popover-before-arrow__inline-end--before)}.uxa-popover.uxa-placement-before[_ngcontent-%COMP%]   .uxa-arrow-foreground[_ngcontent-%COMP%]{border-top:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-bottom:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-start:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);inset-inline-end:var(--uxa-popover-before-arrow__inline-end--after)}.uxa-popover.uxa-placement-after[_ngcontent-%COMP%]{margin-inline-start:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-after[_ngcontent-%COMP%]   .uxa-arrow-background[_ngcontent-%COMP%]{border-top:var(--uxa-popover-arrow__size) solid transparent;border-bottom:var(--uxa-popover-arrow__size) solid transparent;border-inline-end:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color);inset-inline-start:var(--uxa-popover-after-arrow__inline-start--before)}.uxa-popover.uxa-placement-after[_ngcontent-%COMP%]   .uxa-arrow-foreground[_ngcontent-%COMP%]{border-top:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-bottom:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-end:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);inset-inline-start:var(--uxa-popover-after-arrow__inline-start--after)}.uxa-popover-content[_ngcontent-%COMP%]{padding-inline:var(--uxa-popover__padding-inline);padding-block:var(--uxa-popover__padding-block);overflow:hidden auto}  .cdk-overlay-container,   .cdk-global-overlay-wrapper{pointer-events:none;top:0;left:0;height:100%;width:100%}  .cdk-overlay-container{position:fixed;z-index:1000}  .cdk-overlay-container:empty{display:none}  .cdk-global-overlay-wrapper{display:flex;position:absolute;z-index:1000}  .cdk-overlay-pane{position:absolute;pointer-events:auto;box-sizing:border-box;z-index:1000;display:flex;max-width:100%;max-height:100%}  .cdk-overlay-backdrop{position:absolute;inset:0;z-index:1000;pointer-events:auto;-webkit-tap-highlight-color:transparent;transition:opacity .4s cubic-bezier(.25,.8,.25,1);opacity:0}  .cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:1}.cdk-high-contrast-active[_ngcontent-%COMP%]     .cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:.6}  .cdk-overlay-dark-backdrop{background:#00000052}  .cdk-overlay-transparent-backdrop{transition:visibility 1ms linear,opacity 1ms linear;visibility:hidden;opacity:1}  .cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing{opacity:0;visibility:visible}  .cdk-overlay-backdrop-noop-animation{transition:none}  .cdk-overlay-connected-position-bounding-box{position:absolute;z-index:1000;display:flex;flex-direction:column;min-width:1px;min-height:1px}  .cdk-global-scrollblock{position:fixed;width:100%;overflow-y:scroll}[_nghost-%COMP%]{display:block}";
class UxaPopoverComponent {
  constructor() {
    this._changeDetector = inject(ChangeDetectorRef);
    this._elementRef = inject(ElementRef);
    /** @internal */
    this.isMouseInside$ = new BehaviorSubject(false);
    this._variant = 'auto';
    this.arrowBackgroundStyle = null;
    this.arrowForegroundStyle = null;
  }
  /** @internal */
  set variant(variant) {
    this._variant = variant;
    this._changeDetector.detectChanges();
  }
  /** @internal */
  get variant() {
    return this._variant;
  }
  /** @internal */
  set placement(placement) {
    this._placement = placement;
    this._changeDetector.detectChanges();
  }
  /** @internal */
  get placement() {
    return this._placement;
  }
  /** @internal */
  set alignment(alignment) {
    this._alignment = alignment;
    this._changeDetector.detectChanges();
  }
  /** @internal */
  get alignment() {
    return this._alignment;
  }
  /** @internal */
  set content(content) {
    this._content = content;
    this.isTemplatePortal = this._content instanceof TemplatePortal;
    this._changeDetector.markForCheck();
  }
  /** @internal */
  get content() {
    return this._content;
  }
  /** @internal */
  set maxWidth(maxWidth) {
    // this should never need coercion, but it's here because tests fail without it as of v17
    this._maxWidth = coerceCssPixelValue(maxWidth);
    this._changeDetector.detectChanges();
  }
  get maxWidth() {
    return this._maxWidth;
  }
  /** @internal access the template portal, used for type safety in the template */
  get templatePortal() {
    return this._content;
  }
  setArrowPosition(trigger) {
    if (!this.arrowBackgroundRef || !this.arrowForegroundRef) {
      return;
    }
    const {
      arrowBgStyle,
      arrowFgStyle
    } = getArrowPosition(trigger, this._elementRef.nativeElement, this.arrowBackgroundRef.nativeElement, this.arrowForegroundRef.nativeElement, this._placement, this._alignment);
    this.arrowBackgroundStyle = arrowBgStyle;
    this.arrowForegroundStyle = arrowFgStyle;
    this._changeDetector.detectChanges();
  }
  onMouseEnter() {
    this.isMouseInside$.next(true);
  }
  onMouseLeave() {
    this.isMouseInside$.next(false);
  }
  static {
    this.ɵfac = function UxaPopoverComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UxaPopoverComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: UxaPopoverComponent,
      selectors: [["uxa-popover"]],
      viewQuery: function UxaPopoverComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 7);
          i0.ɵɵviewQuery(_c1, 7);
          i0.ɵɵviewQuery(_c2, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.arrowBackgroundRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.arrowForegroundRef = _t.first);
        }
      },
      hostVars: 4,
      hostBindings: function UxaPopoverComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("mouseenter", function UxaPopoverComponent_mouseenter_HostBindingHandler() {
            return ctx.onMouseEnter();
          })("mouseleave", function UxaPopoverComponent_mouseleave_HostBindingHandler() {
            return ctx.onMouseLeave();
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("role", ctx.role)("id", ctx.id);
          i0.ɵɵstyleProp("max-width", ctx.maxWidth);
        }
      },
      inputs: {
        id: "id",
        role: "role",
        variant: "variant",
        placement: "placement",
        alignment: "alignment",
        content: "content",
        maxWidth: "maxWidth"
      },
      decls: 9,
      vars: 17,
      consts: [["contentRef", ""], ["arrowBackgroundRef", ""], ["arrowForegroundRef", ""], ["uxaThemeClass", "", 1, "uxa-popover"], [1, "uxa-arrow-background", 3, "ngStyle"], [1, "uxa-arrow-foreground", 3, "ngStyle"], [1, "uxa-popover-content"], [3, "cdkPortalOutlet"]],
      template: function UxaPopoverComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 3, 0);
          i0.ɵɵelement(2, "div", 4, 1)(4, "div", 5, 2);
          i0.ɵɵelementStart(6, "div", 6);
          i0.ɵɵtemplate(7, UxaPopoverComponent_Conditional_7_Template, 1, 1, null, 7)(8, UxaPopoverComponent_Conditional_8_Template, 2, 1, "span");
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("uxa-placement-above", ctx.placement === "above")("uxa-placement-below", ctx.placement === "below")("uxa-placement-before", ctx.placement === "before")("uxa-placement-after", ctx.placement === "after")("uxa-light", ctx.variant === "light")("uxa-dark", ctx.variant === "dark")("uxa-auto-inverse", ctx.variant === "auto-inverse");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngStyle", ctx.arrowBackgroundStyle);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngStyle", ctx.arrowForegroundStyle);
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(ctx.isTemplatePortal ? 7 : 8);
        }
      },
      dependencies: [UxaThemeClassDirective, NgStyle, CdkPortalOutlet],
      styles: [".uxa-popover[_ngcontent-%COMP%]{display:flex;position:relative;min-width:var(--uxa-popover__min-width);border-radius:var(--uxa-popover__border-radius);filter:var(--uxa-popover__filter);box-shadow:var(--uxa-popover__box-shadow);border:var(--uxa-popover__border-width) var(--uxa-popover__border-style) var(--uxa-popover__border-color);background-color:var(--uxa-popover__background-color);color:var(--uxa-popover__color);font-size:var(--uxa-popover__font-size);font-family:var(--uxa-popover__font-family, var(--uxa-typography__font-family));--uxa-elevation__background-color: var(--uxa-elevation__background-color--4);--uxa-elevation__box-shadow: var(--uxa-elevation__box-shadow--4);--uxa-elevation__border-color: var(--uxa-elevation__border-color--4)}.uxa-popover.uxa-light[_ngcontent-%COMP%]{--uxa-popover__color: var(--uxa-popover__color--light);--uxa-popover__background-color: var(--uxa-popover__background-color--light);--uxa-popover__border-color: var(--uxa-popover__border-color--light)}.uxa-popover.uxa-dark[_ngcontent-%COMP%]{--uxa-popover__color: var(--uxa-popover__color--dark);--uxa-popover__background-color: var(--uxa-popover__background-color--dark);--uxa-popover__border-color: var(--uxa-popover__background-color--dark)}.uxa-popover.uxa-auto-inverse[_ngcontent-%COMP%]{--uxa-popover__color: var(--uxa-popover__color--auto-inverse);--uxa-popover__background-color: var(--uxa-popover__background-color--auto-inverse);--uxa-popover__border-color: var(--uxa-popover__border-color--auto-inverse)}.uxa-popover[_ngcontent-%COMP%]   .uxa-arrow-background[_ngcontent-%COMP%], .uxa-popover[_ngcontent-%COMP%]   .uxa-arrow-foreground[_ngcontent-%COMP%]{content:\"\";position:absolute}.uxa-popover.uxa-placement-below[_ngcontent-%COMP%]{margin-block-start:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-below[_ngcontent-%COMP%]   .uxa-arrow-background[_ngcontent-%COMP%]{top:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:var(--uxa-popover-arrow__size) solid transparent;border-inline-end:var(--uxa-popover-arrow__size) solid transparent;border-bottom:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color)}.uxa-popover.uxa-placement-below[_ngcontent-%COMP%]   .uxa-arrow-foreground[_ngcontent-%COMP%]{top:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-end:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-bottom:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);transform:translateY(var(--uxa-popover__border-width))}.uxa-popover.uxa-placement-above[_ngcontent-%COMP%]{margin-block-end:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-above[_ngcontent-%COMP%]   .uxa-arrow-background[_ngcontent-%COMP%]{bottom:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:var(--uxa-popover-arrow__size) solid transparent;border-inline-end:var(--uxa-popover-arrow__size) solid transparent;border-top:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color)}.uxa-popover.uxa-placement-above[_ngcontent-%COMP%]   .uxa-arrow-foreground[_ngcontent-%COMP%]{bottom:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-end:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-top:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);transform:translateY(calc(var(--uxa-popover__border-width) * -1))}.uxa-popover.uxa-placement-before[_ngcontent-%COMP%]{margin-inline-end:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-before[_ngcontent-%COMP%]   .uxa-arrow-background[_ngcontent-%COMP%]{border-top:var(--uxa-popover-arrow__size) solid transparent;border-bottom:var(--uxa-popover-arrow__size) solid transparent;border-inline-start:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color);inset-inline-end:var(--uxa-popover-before-arrow__inline-end--before)}.uxa-popover.uxa-placement-before[_ngcontent-%COMP%]   .uxa-arrow-foreground[_ngcontent-%COMP%]{border-top:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-bottom:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-start:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);inset-inline-end:var(--uxa-popover-before-arrow__inline-end--after)}.uxa-popover.uxa-placement-after[_ngcontent-%COMP%]{margin-inline-start:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-after[_ngcontent-%COMP%]   .uxa-arrow-background[_ngcontent-%COMP%]{border-top:var(--uxa-popover-arrow__size) solid transparent;border-bottom:var(--uxa-popover-arrow__size) solid transparent;border-inline-end:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color);inset-inline-start:var(--uxa-popover-after-arrow__inline-start--before)}.uxa-popover.uxa-placement-after[_ngcontent-%COMP%]   .uxa-arrow-foreground[_ngcontent-%COMP%]{border-top:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-bottom:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-end:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);inset-inline-start:var(--uxa-popover-after-arrow__inline-start--after)}.uxa-popover-content[_ngcontent-%COMP%]{padding-inline:var(--uxa-popover__padding-inline);padding-block:var(--uxa-popover__padding-block);overflow:hidden auto}  .cdk-overlay-container,   .cdk-global-overlay-wrapper{pointer-events:none;top:0;left:0;height:100%;width:100%}  .cdk-overlay-container{position:fixed;z-index:1000}  .cdk-overlay-container:empty{display:none}  .cdk-global-overlay-wrapper{display:flex;position:absolute;z-index:1000}  .cdk-overlay-pane{position:absolute;pointer-events:auto;box-sizing:border-box;z-index:1000;display:flex;max-width:100%;max-height:100%}  .cdk-overlay-backdrop{position:absolute;inset:0;z-index:1000;pointer-events:auto;-webkit-tap-highlight-color:transparent;transition:opacity .4s cubic-bezier(.25,.8,.25,1);opacity:0}  .cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:1}.cdk-high-contrast-active[_ngcontent-%COMP%]     .cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:.6}  .cdk-overlay-dark-backdrop{background:#00000052}  .cdk-overlay-transparent-backdrop{transition:visibility 1ms linear,opacity 1ms linear;visibility:hidden;opacity:1}  .cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing{opacity:0;visibility:visible}  .cdk-overlay-backdrop-noop-animation{transition:none}  .cdk-overlay-connected-position-bounding-box{position:absolute;z-index:1000;display:flex;flex-direction:column;min-width:1px;min-height:1px}  .cdk-global-scrollblock{position:fixed;width:100%;overflow-y:scroll}[_nghost-%COMP%]{display:block}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UxaPopoverComponent, [{
    type: Component,
    args: [{
      selector: 'uxa-popover',
      changeDetection: ChangeDetectionStrategy.OnPush,
      host: {
        '[attr.role]': 'role',
        '[attr.id]': 'id',
        '[style.max-width]': 'maxWidth'
      },
      standalone: true,
      imports: [UxaThemeClassDirective, NgStyle, CdkPortalOutlet],
      template: "<div\n  #contentRef\n  class=\"uxa-popover\"\n  [class.uxa-placement-above]=\"placement === 'above'\"\n  [class.uxa-placement-below]=\"placement === 'below'\"\n  [class.uxa-placement-before]=\"placement === 'before'\"\n  [class.uxa-placement-after]=\"placement === 'after'\"\n  [class.uxa-light]=\"variant === 'light'\"\n  [class.uxa-dark]=\"variant === 'dark'\"\n  [class.uxa-auto-inverse]=\"variant === 'auto-inverse'\"\n  uxaThemeClass\n>\n  <div class=\"uxa-arrow-background\" #arrowBackgroundRef [ngStyle]=\"arrowBackgroundStyle\"></div>\n  <div class=\"uxa-arrow-foreground\" #arrowForegroundRef [ngStyle]=\"arrowForegroundStyle\"></div>\n  <div class=\"uxa-popover-content\">\n    @if (isTemplatePortal) {\n      <ng-template [cdkPortalOutlet]=\"templatePortal\" />\n    } @else {\n      <span>{{ content }}</span>\n    }\n  </div>\n</div>\n",
      styles: [".uxa-popover{display:flex;position:relative;min-width:var(--uxa-popover__min-width);border-radius:var(--uxa-popover__border-radius);filter:var(--uxa-popover__filter);box-shadow:var(--uxa-popover__box-shadow);border:var(--uxa-popover__border-width) var(--uxa-popover__border-style) var(--uxa-popover__border-color);background-color:var(--uxa-popover__background-color);color:var(--uxa-popover__color);font-size:var(--uxa-popover__font-size);font-family:var(--uxa-popover__font-family, var(--uxa-typography__font-family));--uxa-elevation__background-color: var(--uxa-elevation__background-color--4);--uxa-elevation__box-shadow: var(--uxa-elevation__box-shadow--4);--uxa-elevation__border-color: var(--uxa-elevation__border-color--4)}.uxa-popover.uxa-light{--uxa-popover__color: var(--uxa-popover__color--light);--uxa-popover__background-color: var(--uxa-popover__background-color--light);--uxa-popover__border-color: var(--uxa-popover__border-color--light)}.uxa-popover.uxa-dark{--uxa-popover__color: var(--uxa-popover__color--dark);--uxa-popover__background-color: var(--uxa-popover__background-color--dark);--uxa-popover__border-color: var(--uxa-popover__background-color--dark)}.uxa-popover.uxa-auto-inverse{--uxa-popover__color: var(--uxa-popover__color--auto-inverse);--uxa-popover__background-color: var(--uxa-popover__background-color--auto-inverse);--uxa-popover__border-color: var(--uxa-popover__border-color--auto-inverse)}.uxa-popover .uxa-arrow-background,.uxa-popover .uxa-arrow-foreground{content:\"\";position:absolute}.uxa-popover.uxa-placement-below{margin-block-start:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-below .uxa-arrow-background{top:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:var(--uxa-popover-arrow__size) solid transparent;border-inline-end:var(--uxa-popover-arrow__size) solid transparent;border-bottom:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color)}.uxa-popover.uxa-placement-below .uxa-arrow-foreground{top:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-end:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-bottom:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);transform:translateY(var(--uxa-popover__border-width))}.uxa-popover.uxa-placement-above{margin-block-end:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-above .uxa-arrow-background{bottom:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:var(--uxa-popover-arrow__size) solid transparent;border-inline-end:var(--uxa-popover-arrow__size) solid transparent;border-top:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color)}.uxa-popover.uxa-placement-above .uxa-arrow-foreground{bottom:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-end:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-top:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);transform:translateY(calc(var(--uxa-popover__border-width) * -1))}.uxa-popover.uxa-placement-before{margin-inline-end:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-before .uxa-arrow-background{border-top:var(--uxa-popover-arrow__size) solid transparent;border-bottom:var(--uxa-popover-arrow__size) solid transparent;border-inline-start:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color);inset-inline-end:var(--uxa-popover-before-arrow__inline-end--before)}.uxa-popover.uxa-placement-before .uxa-arrow-foreground{border-top:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-bottom:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-start:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);inset-inline-end:var(--uxa-popover-before-arrow__inline-end--after)}.uxa-popover.uxa-placement-after{margin-inline-start:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-after .uxa-arrow-background{border-top:var(--uxa-popover-arrow__size) solid transparent;border-bottom:var(--uxa-popover-arrow__size) solid transparent;border-inline-end:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color);inset-inline-start:var(--uxa-popover-after-arrow__inline-start--before)}.uxa-popover.uxa-placement-after .uxa-arrow-foreground{border-top:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-bottom:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-end:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);inset-inline-start:var(--uxa-popover-after-arrow__inline-start--after)}.uxa-popover-content{padding-inline:var(--uxa-popover__padding-inline);padding-block:var(--uxa-popover__padding-block);overflow:hidden auto}::ng-deep .cdk-overlay-container,::ng-deep .cdk-global-overlay-wrapper{pointer-events:none;top:0;left:0;height:100%;width:100%}::ng-deep .cdk-overlay-container{position:fixed;z-index:1000}::ng-deep .cdk-overlay-container:empty{display:none}::ng-deep .cdk-global-overlay-wrapper{display:flex;position:absolute;z-index:1000}::ng-deep .cdk-overlay-pane{position:absolute;pointer-events:auto;box-sizing:border-box;z-index:1000;display:flex;max-width:100%;max-height:100%}::ng-deep .cdk-overlay-backdrop{position:absolute;inset:0;z-index:1000;pointer-events:auto;-webkit-tap-highlight-color:transparent;transition:opacity .4s cubic-bezier(.25,.8,.25,1);opacity:0}::ng-deep .cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:1}.cdk-high-contrast-active ::ng-deep .cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:.6}::ng-deep .cdk-overlay-dark-backdrop{background:#00000052}::ng-deep .cdk-overlay-transparent-backdrop{transition:visibility 1ms linear,opacity 1ms linear;visibility:hidden;opacity:1}::ng-deep .cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing{opacity:0;visibility:visible}::ng-deep .cdk-overlay-backdrop-noop-animation{transition:none}::ng-deep .cdk-overlay-connected-position-bounding-box{position:absolute;z-index:1000;display:flex;flex-direction:column;min-width:1px;min-height:1px}::ng-deep .cdk-global-scrollblock{position:fixed;width:100%;overflow-y:scroll}:host{display:block}\n"]
    }]
  }], null, {
    id: [{
      type: Input
    }],
    role: [{
      type: Input
    }],
    variant: [{
      type: Input
    }],
    placement: [{
      type: Input
    }],
    alignment: [{
      type: Input
    }],
    content: [{
      type: Input
    }],
    maxWidth: [{
      type: Input
    }],
    contentRef: [{
      type: ViewChild,
      args: ['contentRef', {
        static: true
      }]
    }],
    arrowBackgroundRef: [{
      type: ViewChild,
      args: ['arrowBackgroundRef', {
        static: true
      }]
    }],
    arrowForegroundRef: [{
      type: ViewChild,
      args: ['arrowForegroundRef', {
        static: true
      }]
    }],
    onMouseEnter: [{
      type: HostListener,
      args: ['mouseenter']
    }],
    onMouseLeave: [{
      type: HostListener,
      args: ['mouseleave']
    }]
  });
})();
class UxaFlyoutComponent extends UxaPopoverComponent {
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵUxaFlyoutComponent_BaseFactory;
      return function UxaFlyoutComponent_Factory(__ngFactoryType__) {
        return (ɵUxaFlyoutComponent_BaseFactory || (ɵUxaFlyoutComponent_BaseFactory = i0.ɵɵgetInheritedFactory(UxaFlyoutComponent)))(__ngFactoryType__ || UxaFlyoutComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: UxaFlyoutComponent,
      selectors: [["uxa-flyout"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 10,
      vars: 17,
      consts: [["contentRef", ""], ["arrowBackgroundRef", ""], ["arrowForegroundRef", ""], ["uxaThemeClass", "", 1, "uxa-popover", "uxa-flyout"], [1, "uxa-arrow-background", 3, "ngStyle"], [1, "uxa-arrow-foreground", 3, "ngStyle"], [1, "uxa-flyout-wrapper"], [1, "uxa-popover-content", "uxa-flyout-content"], [3, "cdkPortalOutlet"]],
      template: function UxaFlyoutComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 3, 0);
          i0.ɵɵelement(2, "div", 4, 1)(4, "div", 5, 2);
          i0.ɵɵelementStart(6, "div", 6)(7, "div", 7);
          i0.ɵɵtemplate(8, UxaFlyoutComponent_Conditional_8_Template, 1, 1, null, 8)(9, UxaFlyoutComponent_Conditional_9_Template, 2, 1, "span");
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("uxa-placement-above", ctx.placement === "above")("uxa-placement-below", ctx.placement === "below")("uxa-placement-before", ctx.placement === "before")("uxa-placement-after", ctx.placement === "after")("uxa-light", ctx.variant === "light")("uxa-dark", ctx.variant === "dark")("uxa-auto-inverse", ctx.variant === "auto-inverse");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngStyle", ctx.arrowBackgroundStyle);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngStyle", ctx.arrowForegroundStyle);
          i0.ɵɵadvance(4);
          i0.ɵɵconditional(ctx.isTemplatePortal ? 8 : 9);
        }
      },
      dependencies: [UxaThemeClassDirective, NgStyle, CdkPortalOutlet],
      styles: [".uxa-popover[_ngcontent-%COMP%]{display:flex;position:relative;min-width:var(--uxa-popover__min-width);border-radius:var(--uxa-popover__border-radius);filter:var(--uxa-popover__filter);box-shadow:var(--uxa-popover__box-shadow);border:var(--uxa-popover__border-width) var(--uxa-popover__border-style) var(--uxa-popover__border-color);background-color:var(--uxa-popover__background-color);color:var(--uxa-popover__color);font-size:var(--uxa-popover__font-size);font-family:var(--uxa-popover__font-family, var(--uxa-typography__font-family));--uxa-elevation__background-color: var(--uxa-elevation__background-color--4);--uxa-elevation__box-shadow: var(--uxa-elevation__box-shadow--4);--uxa-elevation__border-color: var(--uxa-elevation__border-color--4)}.uxa-popover.uxa-light[_ngcontent-%COMP%]{--uxa-popover__color: var(--uxa-popover__color--light);--uxa-popover__background-color: var(--uxa-popover__background-color--light);--uxa-popover__border-color: var(--uxa-popover__border-color--light)}.uxa-popover.uxa-dark[_ngcontent-%COMP%]{--uxa-popover__color: var(--uxa-popover__color--dark);--uxa-popover__background-color: var(--uxa-popover__background-color--dark);--uxa-popover__border-color: var(--uxa-popover__background-color--dark)}.uxa-popover.uxa-auto-inverse[_ngcontent-%COMP%]{--uxa-popover__color: var(--uxa-popover__color--auto-inverse);--uxa-popover__background-color: var(--uxa-popover__background-color--auto-inverse);--uxa-popover__border-color: var(--uxa-popover__border-color--auto-inverse)}.uxa-popover[_ngcontent-%COMP%]   .uxa-arrow-background[_ngcontent-%COMP%], .uxa-popover[_ngcontent-%COMP%]   .uxa-arrow-foreground[_ngcontent-%COMP%]{content:\"\";position:absolute}.uxa-popover.uxa-placement-below[_ngcontent-%COMP%]{margin-block-start:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-below[_ngcontent-%COMP%]   .uxa-arrow-background[_ngcontent-%COMP%]{top:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:var(--uxa-popover-arrow__size) solid transparent;border-inline-end:var(--uxa-popover-arrow__size) solid transparent;border-bottom:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color)}.uxa-popover.uxa-placement-below[_ngcontent-%COMP%]   .uxa-arrow-foreground[_ngcontent-%COMP%]{top:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-end:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-bottom:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);transform:translateY(var(--uxa-popover__border-width))}.uxa-popover.uxa-placement-above[_ngcontent-%COMP%]{margin-block-end:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-above[_ngcontent-%COMP%]   .uxa-arrow-background[_ngcontent-%COMP%]{bottom:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:var(--uxa-popover-arrow__size) solid transparent;border-inline-end:var(--uxa-popover-arrow__size) solid transparent;border-top:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color)}.uxa-popover.uxa-placement-above[_ngcontent-%COMP%]   .uxa-arrow-foreground[_ngcontent-%COMP%]{bottom:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-end:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-top:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);transform:translateY(calc(var(--uxa-popover__border-width) * -1))}.uxa-popover.uxa-placement-before[_ngcontent-%COMP%]{margin-inline-end:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-before[_ngcontent-%COMP%]   .uxa-arrow-background[_ngcontent-%COMP%]{border-top:var(--uxa-popover-arrow__size) solid transparent;border-bottom:var(--uxa-popover-arrow__size) solid transparent;border-inline-start:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color);inset-inline-end:var(--uxa-popover-before-arrow__inline-end--before)}.uxa-popover.uxa-placement-before[_ngcontent-%COMP%]   .uxa-arrow-foreground[_ngcontent-%COMP%]{border-top:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-bottom:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-start:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);inset-inline-end:var(--uxa-popover-before-arrow__inline-end--after)}.uxa-popover.uxa-placement-after[_ngcontent-%COMP%]{margin-inline-start:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-after[_ngcontent-%COMP%]   .uxa-arrow-background[_ngcontent-%COMP%]{border-top:var(--uxa-popover-arrow__size) solid transparent;border-bottom:var(--uxa-popover-arrow__size) solid transparent;border-inline-end:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color);inset-inline-start:var(--uxa-popover-after-arrow__inline-start--before)}.uxa-popover.uxa-placement-after[_ngcontent-%COMP%]   .uxa-arrow-foreground[_ngcontent-%COMP%]{border-top:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-bottom:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-end:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);inset-inline-start:var(--uxa-popover-after-arrow__inline-start--after)}.uxa-popover-content[_ngcontent-%COMP%]{padding-inline:var(--uxa-popover__padding-inline);padding-block:var(--uxa-popover__padding-block);overflow:hidden auto}  .cdk-overlay-container,   .cdk-global-overlay-wrapper{pointer-events:none;top:0;left:0;height:100%;width:100%}  .cdk-overlay-container{position:fixed;z-index:1000}  .cdk-overlay-container:empty{display:none}  .cdk-global-overlay-wrapper{display:flex;position:absolute;z-index:1000}  .cdk-overlay-pane{position:absolute;pointer-events:auto;box-sizing:border-box;z-index:1000;display:flex;max-width:100%;max-height:100%}  .cdk-overlay-backdrop{position:absolute;inset:0;z-index:1000;pointer-events:auto;-webkit-tap-highlight-color:transparent;transition:opacity .4s cubic-bezier(.25,.8,.25,1);opacity:0}  .cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:1}.cdk-high-contrast-active[_ngcontent-%COMP%]     .cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:.6}  .cdk-overlay-dark-backdrop{background:#00000052}  .cdk-overlay-transparent-backdrop{transition:visibility 1ms linear,opacity 1ms linear;visibility:hidden;opacity:1}  .cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing{opacity:0;visibility:visible}  .cdk-overlay-backdrop-noop-animation{transition:none}  .cdk-overlay-connected-position-bounding-box{position:absolute;z-index:1000;display:flex;flex-direction:column;min-width:1px;min-height:1px}  .cdk-global-scrollblock{position:fixed;width:100%;overflow-y:scroll}.uxa-popover.uxa-flyout[_ngcontent-%COMP%]{background-color:var(--uxa-flyout__background-color);border-color:var(--uxa-flyout__border-color);color:var(--uxa-flyout__color);position:relative;background-clip:content-box;--uxa-popover__background-color: var(--jato-cta-focus-border);--uxa-popover__border-color: var(--jato-cta-focus-border);--uxa-popover-arrow__size: 6px;--uxa-popover-before-arrow__inline-end--before: calc(var(--uxa-popover-arrow__size) * -1);--uxa-popover-before-arrow__inline-end--after: calc(var(--uxa-popover-arrow__size) * -1);--uxa-popover-after-arrow__inline-start--before: calc(var(--uxa-popover-arrow__size) * -1);--uxa-popover-after-arrow__inline-start--after: calc(var(--uxa-popover-arrow__size) * -1)}.uxa-popover.uxa-flyout[_ngcontent-%COMP%]   .uxa-flyout-wrapper[_ngcontent-%COMP%]{overflow:hidden;border-radius:var(--uxa-flyout-wrapper__border-radius)}.uxa-popover.uxa-flyout.uxa-placement-below[_ngcontent-%COMP%]   .uxa-flyout-content[_ngcontent-%COMP%]{--uxa-popover__padding-inline: var(--uxa-flyout-content__padding-inline--below);--uxa-popover__padding-block: var(--uxa-flyout-content__padding-block--below);box-shadow:var(--uxa-flyout-content__box-shadow--below)}.uxa-popover.uxa-flyout.uxa-placement-above[_ngcontent-%COMP%]   .uxa-flyout-content[_ngcontent-%COMP%]{--uxa-popover__padding-inline: var(--uxa-flyout-content__padding-inline--above);--uxa-popover__padding-block: var(--uxa-flyout-content__padding-block--above);box-shadow:var(--uxa-flyout-content__box-shadow--above)}.uxa-popover.uxa-flyout.uxa-placement-after[_ngcontent-%COMP%]   .uxa-flyout-content[_ngcontent-%COMP%]{--uxa-popover__padding-inline: var(--uxa-flyout-content__padding-inline--after);--uxa-popover__padding-block: var(--uxa-flyout-content__padding-block--after);box-shadow:var(--uxa-flyout-content__box-shadow--after)}.uxa-popover.uxa-flyout.uxa-placement-before[_ngcontent-%COMP%]   .uxa-flyout-content[_ngcontent-%COMP%]{--uxa-popover__padding-inline: var(--uxa-flyout-content__padding-inline--before);--uxa-popover__padding-block: var(--uxa-flyout-content__padding-block--before);box-shadow:var(--uxa-flyout-content__box-shadow--before)}[_nghost-%COMP%]{display:block}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UxaFlyoutComponent, [{
    type: Component,
    args: [{
      selector: 'uxa-flyout',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: true,
      imports: [UxaThemeClassDirective, NgStyle, CdkPortalOutlet],
      template: "<div\n  #contentRef\n  class=\"uxa-popover uxa-flyout\"\n  [class.uxa-placement-above]=\"placement === 'above'\"\n  [class.uxa-placement-below]=\"placement === 'below'\"\n  [class.uxa-placement-before]=\"placement === 'before'\"\n  [class.uxa-placement-after]=\"placement === 'after'\"\n  [class.uxa-light]=\"variant === 'light'\"\n  [class.uxa-dark]=\"variant === 'dark'\"\n  [class.uxa-auto-inverse]=\"variant === 'auto-inverse'\"\n  uxaThemeClass\n>\n  <div class=\"uxa-arrow-background\" #arrowBackgroundRef [ngStyle]=\"arrowBackgroundStyle\"></div>\n  <div class=\"uxa-arrow-foreground\" #arrowForegroundRef [ngStyle]=\"arrowForegroundStyle\"></div>\n  <div class=\"uxa-flyout-wrapper\">\n    <div class=\"uxa-popover-content uxa-flyout-content\">\n      @if (isTemplatePortal) {\n        <ng-template [cdkPortalOutlet]=\"templatePortal\" />\n      } @else {\n        <span>{{ content }}</span>\n      }\n    </div>\n  </div>\n</div>\n",
      styles: [".uxa-popover{display:flex;position:relative;min-width:var(--uxa-popover__min-width);border-radius:var(--uxa-popover__border-radius);filter:var(--uxa-popover__filter);box-shadow:var(--uxa-popover__box-shadow);border:var(--uxa-popover__border-width) var(--uxa-popover__border-style) var(--uxa-popover__border-color);background-color:var(--uxa-popover__background-color);color:var(--uxa-popover__color);font-size:var(--uxa-popover__font-size);font-family:var(--uxa-popover__font-family, var(--uxa-typography__font-family));--uxa-elevation__background-color: var(--uxa-elevation__background-color--4);--uxa-elevation__box-shadow: var(--uxa-elevation__box-shadow--4);--uxa-elevation__border-color: var(--uxa-elevation__border-color--4)}.uxa-popover.uxa-light{--uxa-popover__color: var(--uxa-popover__color--light);--uxa-popover__background-color: var(--uxa-popover__background-color--light);--uxa-popover__border-color: var(--uxa-popover__border-color--light)}.uxa-popover.uxa-dark{--uxa-popover__color: var(--uxa-popover__color--dark);--uxa-popover__background-color: var(--uxa-popover__background-color--dark);--uxa-popover__border-color: var(--uxa-popover__background-color--dark)}.uxa-popover.uxa-auto-inverse{--uxa-popover__color: var(--uxa-popover__color--auto-inverse);--uxa-popover__background-color: var(--uxa-popover__background-color--auto-inverse);--uxa-popover__border-color: var(--uxa-popover__border-color--auto-inverse)}.uxa-popover .uxa-arrow-background,.uxa-popover .uxa-arrow-foreground{content:\"\";position:absolute}.uxa-popover.uxa-placement-below{margin-block-start:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-below .uxa-arrow-background{top:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:var(--uxa-popover-arrow__size) solid transparent;border-inline-end:var(--uxa-popover-arrow__size) solid transparent;border-bottom:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color)}.uxa-popover.uxa-placement-below .uxa-arrow-foreground{top:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-end:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-bottom:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);transform:translateY(var(--uxa-popover__border-width))}.uxa-popover.uxa-placement-above{margin-block-end:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-above .uxa-arrow-background{bottom:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:var(--uxa-popover-arrow__size) solid transparent;border-inline-end:var(--uxa-popover-arrow__size) solid transparent;border-top:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color)}.uxa-popover.uxa-placement-above .uxa-arrow-foreground{bottom:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-end:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-top:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);transform:translateY(calc(var(--uxa-popover__border-width) * -1))}.uxa-popover.uxa-placement-before{margin-inline-end:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-before .uxa-arrow-background{border-top:var(--uxa-popover-arrow__size) solid transparent;border-bottom:var(--uxa-popover-arrow__size) solid transparent;border-inline-start:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color);inset-inline-end:var(--uxa-popover-before-arrow__inline-end--before)}.uxa-popover.uxa-placement-before .uxa-arrow-foreground{border-top:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-bottom:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-start:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);inset-inline-end:var(--uxa-popover-before-arrow__inline-end--after)}.uxa-popover.uxa-placement-after{margin-inline-start:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-after .uxa-arrow-background{border-top:var(--uxa-popover-arrow__size) solid transparent;border-bottom:var(--uxa-popover-arrow__size) solid transparent;border-inline-end:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color);inset-inline-start:var(--uxa-popover-after-arrow__inline-start--before)}.uxa-popover.uxa-placement-after .uxa-arrow-foreground{border-top:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-bottom:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-end:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);inset-inline-start:var(--uxa-popover-after-arrow__inline-start--after)}.uxa-popover-content{padding-inline:var(--uxa-popover__padding-inline);padding-block:var(--uxa-popover__padding-block);overflow:hidden auto}::ng-deep .cdk-overlay-container,::ng-deep .cdk-global-overlay-wrapper{pointer-events:none;top:0;left:0;height:100%;width:100%}::ng-deep .cdk-overlay-container{position:fixed;z-index:1000}::ng-deep .cdk-overlay-container:empty{display:none}::ng-deep .cdk-global-overlay-wrapper{display:flex;position:absolute;z-index:1000}::ng-deep .cdk-overlay-pane{position:absolute;pointer-events:auto;box-sizing:border-box;z-index:1000;display:flex;max-width:100%;max-height:100%}::ng-deep .cdk-overlay-backdrop{position:absolute;inset:0;z-index:1000;pointer-events:auto;-webkit-tap-highlight-color:transparent;transition:opacity .4s cubic-bezier(.25,.8,.25,1);opacity:0}::ng-deep .cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:1}.cdk-high-contrast-active ::ng-deep .cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:.6}::ng-deep .cdk-overlay-dark-backdrop{background:#00000052}::ng-deep .cdk-overlay-transparent-backdrop{transition:visibility 1ms linear,opacity 1ms linear;visibility:hidden;opacity:1}::ng-deep .cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing{opacity:0;visibility:visible}::ng-deep .cdk-overlay-backdrop-noop-animation{transition:none}::ng-deep .cdk-overlay-connected-position-bounding-box{position:absolute;z-index:1000;display:flex;flex-direction:column;min-width:1px;min-height:1px}::ng-deep .cdk-global-scrollblock{position:fixed;width:100%;overflow-y:scroll}.uxa-popover.uxa-flyout{background-color:var(--uxa-flyout__background-color);border-color:var(--uxa-flyout__border-color);color:var(--uxa-flyout__color);position:relative;background-clip:content-box;--uxa-popover__background-color: var(--jato-cta-focus-border);--uxa-popover__border-color: var(--jato-cta-focus-border);--uxa-popover-arrow__size: 6px;--uxa-popover-before-arrow__inline-end--before: calc(var(--uxa-popover-arrow__size) * -1);--uxa-popover-before-arrow__inline-end--after: calc(var(--uxa-popover-arrow__size) * -1);--uxa-popover-after-arrow__inline-start--before: calc(var(--uxa-popover-arrow__size) * -1);--uxa-popover-after-arrow__inline-start--after: calc(var(--uxa-popover-arrow__size) * -1)}.uxa-popover.uxa-flyout .uxa-flyout-wrapper{overflow:hidden;border-radius:var(--uxa-flyout-wrapper__border-radius)}.uxa-popover.uxa-flyout.uxa-placement-below .uxa-flyout-content{--uxa-popover__padding-inline: var(--uxa-flyout-content__padding-inline--below);--uxa-popover__padding-block: var(--uxa-flyout-content__padding-block--below);box-shadow:var(--uxa-flyout-content__box-shadow--below)}.uxa-popover.uxa-flyout.uxa-placement-above .uxa-flyout-content{--uxa-popover__padding-inline: var(--uxa-flyout-content__padding-inline--above);--uxa-popover__padding-block: var(--uxa-flyout-content__padding-block--above);box-shadow:var(--uxa-flyout-content__box-shadow--above)}.uxa-popover.uxa-flyout.uxa-placement-after .uxa-flyout-content{--uxa-popover__padding-inline: var(--uxa-flyout-content__padding-inline--after);--uxa-popover__padding-block: var(--uxa-flyout-content__padding-block--after);box-shadow:var(--uxa-flyout-content__box-shadow--after)}.uxa-popover.uxa-flyout.uxa-placement-before .uxa-flyout-content{--uxa-popover__padding-inline: var(--uxa-flyout-content__padding-inline--before);--uxa-popover__padding-block: var(--uxa-flyout-content__padding-block--before);box-shadow:var(--uxa-flyout-content__box-shadow--before)}:host{display:block}\n"]
    }]
  }], null, null);
})();
class UxaTooltipComponent extends UxaPopoverComponent {
  static {
    this.ɵfac = /* @__PURE__ */(() => {
      let ɵUxaTooltipComponent_BaseFactory;
      return function UxaTooltipComponent_Factory(__ngFactoryType__) {
        return (ɵUxaTooltipComponent_BaseFactory || (ɵUxaTooltipComponent_BaseFactory = i0.ɵɵgetInheritedFactory(UxaTooltipComponent)))(__ngFactoryType__ || UxaTooltipComponent);
      };
    })();
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: UxaTooltipComponent,
      selectors: [["uxa-tooltip"]],
      features: [i0.ɵɵInheritDefinitionFeature],
      decls: 9,
      vars: 17,
      consts: [["contentRef", ""], ["arrowBackgroundRef", ""], ["arrowForegroundRef", ""], ["uxaThemeClass", "", 1, "uxa-popover"], [1, "uxa-arrow-background", 3, "ngStyle"], [1, "uxa-arrow-foreground", 3, "ngStyle"], [1, "uxa-popover-content"], [3, "cdkPortalOutlet"]],
      template: function UxaTooltipComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 3, 0);
          i0.ɵɵelement(2, "div", 4, 1)(4, "div", 5, 2);
          i0.ɵɵelementStart(6, "div", 6);
          i0.ɵɵtemplate(7, UxaTooltipComponent_Conditional_7_Template, 1, 1, null, 7)(8, UxaTooltipComponent_Conditional_8_Template, 2, 1, "span");
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵclassProp("uxa-placement-above", ctx.placement === "above")("uxa-placement-below", ctx.placement === "below")("uxa-placement-before", ctx.placement === "before")("uxa-placement-after", ctx.placement === "after")("uxa-light", ctx.variant === "light")("uxa-dark", ctx.variant === "dark")("uxa-auto-inverse", ctx.variant === "auto-inverse");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngStyle", ctx.arrowBackgroundStyle);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngStyle", ctx.arrowForegroundStyle);
          i0.ɵɵadvance(3);
          i0.ɵɵconditional(ctx.isTemplatePortal ? 7 : 8);
        }
      },
      dependencies: [UxaThemeClassDirective, NgStyle, CdkPortalOutlet],
      styles: [_c3],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UxaTooltipComponent, [{
    type: Component,
    args: [{
      selector: 'uxa-tooltip',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: true,
      imports: [UxaThemeClassDirective, NgStyle, CdkPortalOutlet],
      template: "<div\n  #contentRef\n  class=\"uxa-popover\"\n  [class.uxa-placement-above]=\"placement === 'above'\"\n  [class.uxa-placement-below]=\"placement === 'below'\"\n  [class.uxa-placement-before]=\"placement === 'before'\"\n  [class.uxa-placement-after]=\"placement === 'after'\"\n  [class.uxa-light]=\"variant === 'light'\"\n  [class.uxa-dark]=\"variant === 'dark'\"\n  [class.uxa-auto-inverse]=\"variant === 'auto-inverse'\"\n  uxaThemeClass\n>\n  <div class=\"uxa-arrow-background\" #arrowBackgroundRef [ngStyle]=\"arrowBackgroundStyle\"></div>\n  <div class=\"uxa-arrow-foreground\" #arrowForegroundRef [ngStyle]=\"arrowForegroundStyle\"></div>\n  <div class=\"uxa-popover-content\">\n    @if (isTemplatePortal) {\n      <ng-template [cdkPortalOutlet]=\"templatePortal\" />\n    } @else {\n      <span>{{ content }}</span>\n    }\n  </div>\n</div>\n",
      styles: [".uxa-popover{display:flex;position:relative;min-width:var(--uxa-popover__min-width);border-radius:var(--uxa-popover__border-radius);filter:var(--uxa-popover__filter);box-shadow:var(--uxa-popover__box-shadow);border:var(--uxa-popover__border-width) var(--uxa-popover__border-style) var(--uxa-popover__border-color);background-color:var(--uxa-popover__background-color);color:var(--uxa-popover__color);font-size:var(--uxa-popover__font-size);font-family:var(--uxa-popover__font-family, var(--uxa-typography__font-family));--uxa-elevation__background-color: var(--uxa-elevation__background-color--4);--uxa-elevation__box-shadow: var(--uxa-elevation__box-shadow--4);--uxa-elevation__border-color: var(--uxa-elevation__border-color--4)}.uxa-popover.uxa-light{--uxa-popover__color: var(--uxa-popover__color--light);--uxa-popover__background-color: var(--uxa-popover__background-color--light);--uxa-popover__border-color: var(--uxa-popover__border-color--light)}.uxa-popover.uxa-dark{--uxa-popover__color: var(--uxa-popover__color--dark);--uxa-popover__background-color: var(--uxa-popover__background-color--dark);--uxa-popover__border-color: var(--uxa-popover__background-color--dark)}.uxa-popover.uxa-auto-inverse{--uxa-popover__color: var(--uxa-popover__color--auto-inverse);--uxa-popover__background-color: var(--uxa-popover__background-color--auto-inverse);--uxa-popover__border-color: var(--uxa-popover__border-color--auto-inverse)}.uxa-popover .uxa-arrow-background,.uxa-popover .uxa-arrow-foreground{content:\"\";position:absolute}.uxa-popover.uxa-placement-below{margin-block-start:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-below .uxa-arrow-background{top:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:var(--uxa-popover-arrow__size) solid transparent;border-inline-end:var(--uxa-popover-arrow__size) solid transparent;border-bottom:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color)}.uxa-popover.uxa-placement-below .uxa-arrow-foreground{top:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-end:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-bottom:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);transform:translateY(var(--uxa-popover__border-width))}.uxa-popover.uxa-placement-above{margin-block-end:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-above .uxa-arrow-background{bottom:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:var(--uxa-popover-arrow__size) solid transparent;border-inline-end:var(--uxa-popover-arrow__size) solid transparent;border-top:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color)}.uxa-popover.uxa-placement-above .uxa-arrow-foreground{bottom:calc(var(--uxa-popover-arrow__size) * -1);border-inline-start:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-end:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-top:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);transform:translateY(calc(var(--uxa-popover__border-width) * -1))}.uxa-popover.uxa-placement-before{margin-inline-end:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-before .uxa-arrow-background{border-top:var(--uxa-popover-arrow__size) solid transparent;border-bottom:var(--uxa-popover-arrow__size) solid transparent;border-inline-start:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color);inset-inline-end:var(--uxa-popover-before-arrow__inline-end--before)}.uxa-popover.uxa-placement-before .uxa-arrow-foreground{border-top:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-bottom:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-start:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);inset-inline-end:var(--uxa-popover-before-arrow__inline-end--after)}.uxa-popover.uxa-placement-after{margin-inline-start:var(--uxa-popover-arrow__size)}.uxa-popover.uxa-placement-after .uxa-arrow-background{border-top:var(--uxa-popover-arrow__size) solid transparent;border-bottom:var(--uxa-popover-arrow__size) solid transparent;border-inline-end:var(--uxa-popover-arrow__size) solid var(--uxa-popover__border-color);inset-inline-start:var(--uxa-popover-after-arrow__inline-start--before)}.uxa-popover.uxa-placement-after .uxa-arrow-foreground{border-top:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-bottom:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid transparent;border-inline-end:calc(var(--uxa-popover-arrow__size) - var(--uxa-popover__border-width)) solid var(--uxa-popover__background-color);inset-inline-start:var(--uxa-popover-after-arrow__inline-start--after)}.uxa-popover-content{padding-inline:var(--uxa-popover__padding-inline);padding-block:var(--uxa-popover__padding-block);overflow:hidden auto}::ng-deep .cdk-overlay-container,::ng-deep .cdk-global-overlay-wrapper{pointer-events:none;top:0;left:0;height:100%;width:100%}::ng-deep .cdk-overlay-container{position:fixed;z-index:1000}::ng-deep .cdk-overlay-container:empty{display:none}::ng-deep .cdk-global-overlay-wrapper{display:flex;position:absolute;z-index:1000}::ng-deep .cdk-overlay-pane{position:absolute;pointer-events:auto;box-sizing:border-box;z-index:1000;display:flex;max-width:100%;max-height:100%}::ng-deep .cdk-overlay-backdrop{position:absolute;inset:0;z-index:1000;pointer-events:auto;-webkit-tap-highlight-color:transparent;transition:opacity .4s cubic-bezier(.25,.8,.25,1);opacity:0}::ng-deep .cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:1}.cdk-high-contrast-active ::ng-deep .cdk-overlay-backdrop.cdk-overlay-backdrop-showing{opacity:.6}::ng-deep .cdk-overlay-dark-backdrop{background:#00000052}::ng-deep .cdk-overlay-transparent-backdrop{transition:visibility 1ms linear,opacity 1ms linear;visibility:hidden;opacity:1}::ng-deep .cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing{opacity:0;visibility:visible}::ng-deep .cdk-overlay-backdrop-noop-animation{transition:none}::ng-deep .cdk-overlay-connected-position-bounding-box{position:absolute;z-index:1000;display:flex;flex-direction:column;min-width:1px;min-height:1px}::ng-deep .cdk-global-scrollblock{position:fixed;width:100%;overflow-y:scroll}:host{display:block}\n"]
    }]
  }], null, null);
})();
const UxaFlyoutConfigToken = new InjectionToken('UxaFlyoutConfiguration');
const defaultFlyoutConfig = {
  maxWidth: undefined,
  variant: 'auto',
  placement: 'below',
  alignment: 'center'
};
/**
 * Provide the default Flyout configuration
 * @param config The Flyout configuration
 * @returns The provider
 */
function provideFlyoutConfig(config) {
  return [{
    provide: UxaFlyoutConfigToken,
    useValue: {
      ...defaultFlyoutConfig,
      ...config
    }
  }];
}
/**
 * Inject the Flyout configuration
 * @returns The global Flyout configuration
 */
function injectFlyoutConfig() {
  return inject(UxaFlyoutConfigToken, {
    optional: true
  }) ?? defaultFlyoutConfig;
}
const UxaPopoverConfigToken = new InjectionToken('UxaPopoverConfiguration');
const defaultPopoverConfig = {
  maxWidth: undefined,
  variant: 'auto',
  placement: 'below',
  alignment: 'center'
};
/**
 * Provide the default Popover configuration
 * @param config The Popover configuration
 * @returns The provider
 */
function providePopoverConfig(config) {
  return [{
    provide: UxaPopoverConfigToken,
    useValue: {
      ...defaultPopoverConfig,
      ...config
    }
  }];
}
/**
 * Inject the Popover configuration
 * @returns The global Popover configuration
 */
function injectPopoverConfig() {
  return inject(UxaPopoverConfigToken, {
    optional: true
  }) ?? defaultPopoverConfig;
}
const UxaTooltipConfigToken = new InjectionToken('UxaTooltipConfiguration');
const defaultTooltipConfig = {
  maxWidth: undefined,
  variant: 'auto',
  placement: 'below',
  alignment: 'center'
};
/**
 * Provide the default Tooltip configuration
 * @param config The Tooltip configuration
 * @returns The provider
 */
function provideTooltipConfig(config) {
  return [{
    provide: UxaTooltipConfigToken,
    useValue: {
      ...defaultTooltipConfig,
      ...config
    }
  }];
}
/**
 * Inject the Tooltip configuration
 * @returns The global Tooltip configuration
 */
function injectTooltipConfig() {
  return inject(UxaTooltipConfigToken, {
    optional: true
  }) ?? defaultTooltipConfig;
}
class OverlayPlacement {
  constructor() {
    this._dir = inject(Directionality);
  }
  updatePosition(overlayRef, placement, alignment, offset = 0) {
    const originPosition = this.getOriginPosition(placement, alignment);
    const overlayPosition = this.getOverlayPosition(placement, alignment);
    let connectedPositions = [];
    const positions = [{
      originX: originPosition.position.originX,
      originY: originPosition.position.originY,
      overlayX: overlayPosition.position.overlayX,
      overlayY: overlayPosition.position.overlayY
    }, {
      originX: originPosition.fallbackPlacement.originX,
      originY: originPosition.fallbackPlacement.originY,
      overlayX: overlayPosition.fallbackPlacement.overlayX,
      overlayY: overlayPosition.fallbackPlacement.overlayY
    }];
    if (alignment === 'center') {
      let centerPositions = [...positions];
      if (placement === 'above' || placement === 'below') {
        centerPositions = [...centerPositions, ...this.getCenterFallbackPositions(originPosition, overlayPosition),
        // if the popover cannot fit above or below, fallback to left center
        {
          originX: 'start',
          originY: 'center',
          overlayX: 'end',
          overlayY: 'center'
        },
        // fallback to right center
        {
          originX: 'end',
          originY: 'center',
          overlayX: 'start',
          overlayY: 'center'
        }];
      }
      connectedPositions = centerPositions;
    } else {
      connectedPositions = [...positions, {
        originX: originPosition.fallbackAlignment.originX,
        originY: originPosition.fallbackAlignment.originY,
        overlayX: overlayPosition.fallbackAlignment.overlayX,
        overlayY: overlayPosition.fallbackAlignment.overlayY
      }, {
        originX: originPosition.fallbackInverted.originX,
        originY: originPosition.fallbackInverted.originY,
        overlayX: overlayPosition.fallbackInverted.overlayX,
        overlayY: overlayPosition.fallbackInverted.overlayY
      }];
    }
    connectedPositions = connectedPositions.map(position => this.addOffset(position, offset));
    this.getPositionStrategy(overlayRef).withPositions(connectedPositions);
  }
  getPositionStrategy(overlayRef) {
    return overlayRef.getConfig().positionStrategy;
  }
  getOriginPosition(placement, alignment) {
    let position = {
      originX: alignment ?? 'center',
      originY: 'bottom'
    };
    let alignmentPosition = 'center';
    if (placement === 'above') {
      position = {
        originX: alignment,
        originY: 'top'
      };
    }
    if (placement === 'before') {
      if (alignment !== 'center') {
        alignmentPosition = alignment === 'start' ? 'top' : 'bottom';
      }
      position = {
        originX: 'start',
        originY: alignmentPosition
      };
    }
    if (placement === 'after') {
      if (alignment !== 'center') {
        alignmentPosition = alignment === 'start' ? 'top' : 'bottom';
      }
      position = {
        originX: 'end',
        originY: alignmentPosition
      };
    }
    const {
      x: placementX,
      y: placementY
    } = this.getInvertedPlacementPosition(placement, position.originX, position.originY);
    const {
      x: alignmentX,
      y: alignmentY
    } = this.getInvertedAlignmentPosition(placement, position.originX, position.originY);
    const {
      x: invertedX,
      y: invertedY
    } = this.getInvertedPosition(position.originX, position.originY);
    return {
      position,
      fallbackPlacement: {
        originX: placementX,
        originY: placementY
      },
      fallbackAlignment: {
        originX: alignmentX,
        originY: alignmentY
      },
      fallbackInverted: {
        originX: invertedX,
        originY: invertedY
      }
    };
  }
  addOffset(position, offset = 0) {
    if (offset === 0) {
      return position;
    }
    const isLtr = !this._dir || this._dir.value === 'ltr';
    if (position.originY === 'top') {
      position.offsetY = -offset;
    } else if (position.originY === 'bottom') {
      position.offsetY = offset;
    } else if (position.originX === 'start') {
      position.offsetX = isLtr ? -offset : offset;
    } else if (position.originX === 'end') {
      position.offsetX = isLtr ? offset : -offset;
    }
    return position;
  }
  getOverlayPosition(placement, alignment) {
    let position = {
      overlayX: alignment ?? 'center',
      overlayY: 'top'
    };
    let alignmentPosition = 'center';
    if (placement === 'above') {
      position = {
        overlayX: alignment,
        overlayY: 'bottom'
      };
    }
    if (placement === 'before') {
      if (alignment !== 'center') {
        alignmentPosition = alignment === 'start' ? 'top' : 'bottom';
      }
      position = {
        overlayX: 'end',
        overlayY: alignmentPosition
      };
    }
    if (placement === 'after') {
      if (alignment !== 'center') {
        alignmentPosition = alignment === 'start' ? 'top' : 'bottom';
      }
      position = {
        overlayX: 'start',
        overlayY: alignmentPosition
      };
    }
    const {
      x: placementX,
      y: placementY
    } = this.getInvertedPlacementPosition(placement, position.overlayX, position.overlayY);
    if (alignment === 'center') {
      return {
        position,
        fallbackPlacement: {
          overlayX: placementX,
          overlayY: placementY
        }
      };
    } else {
      const {
        x: alignmentX,
        y: alignmentY
      } = this.getInvertedAlignmentPosition(placement, position.overlayX, position.overlayY);
      const {
        x: invertedX,
        y: invertedY
      } = this.getInvertedPosition(position.overlayX, position.overlayY);
      return {
        position,
        fallbackPlacement: {
          overlayX: placementX,
          overlayY: placementY
        },
        fallbackAlignment: {
          overlayX: alignmentX,
          overlayY: alignmentY
        },
        fallbackInverted: {
          overlayX: invertedX,
          overlayY: invertedY
        }
      };
    }
  }
  getInvertedPlacementPosition(placement, x, y) {
    if (placement === 'above' || placement === 'below') {
      if (y === 'top') {
        y = 'bottom';
      } else if (y === 'bottom') {
        y = 'top';
      }
    } else {
      if (x === 'end') {
        x = 'start';
      } else if (x === 'start') {
        x = 'end';
      }
    }
    return {
      x,
      y
    };
  }
  getInvertedAlignmentPosition(placement, x, y) {
    if (placement === 'above' || placement === 'below') {
      if (x === 'end') {
        x = 'start';
      } else if (x === 'start') {
        x = 'end';
      }
    } else {
      if (y === 'top') {
        y = 'bottom';
      } else if (y === 'bottom') {
        y = 'top';
      }
    }
    return {
      x,
      y
    };
  }
  getInvertedPosition(x, y) {
    if (x === 'end') {
      x = 'start';
    } else if (x === 'start') {
      x = 'end';
    }
    if (y === 'top') {
      y = 'bottom';
    } else if (y === 'bottom') {
      y = 'top';
    }
    return {
      x,
      y
    };
  }
  getCenterFallbackPositions(originPosition, overlayPosition) {
    const positions = [{
      originX: 'start',
      originY: originPosition.position.originY,
      overlayX: 'start',
      overlayY: overlayPosition.position.overlayY
    }, {
      originX: 'end',
      originY: originPosition.position.originY,
      overlayX: 'end',
      overlayY: overlayPosition.position.overlayY
    }, {
      originX: 'start',
      originY: originPosition.fallbackPlacement.originY,
      overlayX: 'start',
      overlayY: overlayPosition.fallbackPlacement.overlayY
    }, {
      originX: 'end',
      originY: originPosition.fallbackPlacement.originY,
      overlayX: 'end',
      overlayY: overlayPosition.fallbackPlacement.overlayY
    }];
    return positions;
  }
  static {
    this.ɵfac = function OverlayPlacement_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || OverlayPlacement)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: OverlayPlacement,
      factory: OverlayPlacement.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OverlayPlacement, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
let uniqueId$2 = 0;
class UxaPopoverDirective {
  constructor() {
    this._document = inject(DOCUMENT);
    this._platform = inject(PLATFORM_ID);
    this.config = injectPopoverConfig();
    this._destroyRef = inject(DestroyRef);
    this._injector = inject(Injector);
    this._overlayPlacement = inject(OverlayPlacement);
    this._elementRef = inject(ElementRef);
    this._viewContainerRef = inject(ViewContainerRef);
    this._overlay = inject(Overlay);
    this._directionality = inject(UxaDirectionality);
    this._focusMonitor = inject(FocusMonitor);
    this._zone = inject(NgZone);
    /** Set the id of popover. */
    this.id = `uxa-popover-${uniqueId$2++}`;
    /** Set the open or closed state of the popover. */
    this.open = false;
    /** Prevent the popover from being opened. */
    this.disabled = false;
    /** Customize the popover role. */
    this.role = 'tooltip';
    /** The color variant of the popover. */
    this.variant = this.config.variant;
    /** The position of the popover relative to the trigger element. */
    this.placement = this.config.placement;
    /** The alignment of the popover relative to the trigger element. */
    this.alignment = this.config.alignment;
    /** Define a maximum width for the popover. This can be a number or a string with a unit (e.g. "300px"). */
    this.maxWidth = coerceCssPixelValue(this.config.maxWidth);
    /** A list of events that will cause the popover to appear. Possible events are click, mouseenter and focus. */
    this.openTriggers = ['click'];
    /** A list of events that will cause the popover to hide. Possible events are click, mouseleave, blur, escape, clickoutside and mouseoutside. */
    this.closeTriggers = ['clickoutside'];
    /** Emit whenever the popover is opened or closed. */
    this.openChange = new EventEmitter();
    /**
     * Define an distance a popover should be offset from its trigger.
     */
    this.offset = 0;
    this.delay = 0;
    this._isMouseInside$ = new Subject();
    this._didClose$ = new Subject();
    this._show$ = new Subject();
    /** Whether we should listen to resize events, this is used to prevent infinite recalculations. */
    this._listenForResize = true;
  }
  /** The popover content. This can be text content or a TemplateRef for more advanced content. */
  set content(content) {
    this._content = content;
    this.updateContent();
  }
  get content() {
    return this._content;
  }
  ngOnInit() {
    this._directionality.dirChange$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe(() => {
      this._overlayRef?.setDirection(this._directionality.dir);
      this._overlayRef?.updatePosition();
    });
    if (this.open) {
      this.show();
    }
    fromEvent(this._elementRef.nativeElement, 'click').pipe(takeUntilDestroyed(this._destroyRef)).subscribe(() => this.onClick());
    fromEvent(this._elementRef.nativeElement, 'mouseenter').pipe(takeUntilDestroyed(this._destroyRef)).subscribe(() => {
      this._isMouseInside$.next(true);
      this.onMouseEnter();
    });
    fromEvent(this._elementRef.nativeElement, 'mouseleave').pipe(tap(() => this._isMouseInside$.next(false)), filter(() =>
    // if the popover isn't visible due to a delay, we still want to trigger onMouseLeave if the mouse leaves the trigger element, to prevent multiple popovers appearing
    this.closeTriggers.includes('mouseleave') || this.closeTriggers.includes('mouseoutside') && !this._overlayRef?.hasAttached()), takeUntilDestroyed(this._destroyRef)).subscribe(() => this.onMouseLeave());
    this._focusMonitor.monitor(this._elementRef).pipe(takeUntilDestroyed(this._destroyRef)).subscribe(origin => {
      // if the origin is a mouse event or programmatic then we don't want to show the popover. The use case is is a button has both a tooltip
      // and a menu, if I click on the menu item then the tooltip should not show when focus is be returned to the trigger element
      if (origin === 'keyboard') {
        this.onFocus();
      }
    });
    fromEvent(this._elementRef.nativeElement, 'blur').pipe(takeUntilDestroyed(this._destroyRef)).subscribe(() => this.onBlur());
    // begin showing the popover after the delay, however listen for close events and cancel the timer if the popover is closed
    // before the timer completes
    this._show$.pipe(switchMap(() => timer(this.delay).pipe(takeUntil(this._didClose$))), takeUntilDestroyed(this._destroyRef)).subscribe(() => this.show());
  }
  ngOnDestroy() {
    this.close();
  }
  ngOnChanges(changes) {
    if (('content' in changes || 'uxaTooltip' in changes) && this._popoverRef) {
      this.updateContent();
    }
    if ('open' in changes || 'uxaTooltipOpen' in changes) {
      this.open ? this.show() : this.close();
    }
    if (('disabled' in changes || 'uxaTooltipDisabled' in changes) && this.disabled === true && this._overlayRef?.hasAttached()) {
      this._overlayRef.detach();
    }
    if (('disabled' in changes || 'uxaTooltipDisabled' in changes) && this.disabled !== true && this.open) {
      this.show();
    }
    if (('variant' in changes || 'uxaTooltipVariant' in changes) && this._popoverRef) {
      this._popoverRef.instance.variant = this.variant;
    }
    if (('placement' in changes || 'uxaTooltipPlacement' in changes || 'alignment' in changes || 'uxaTooltipAlignment' in changes || 'offset' in changes || 'uxaTooltipOffset' in changes) && this._overlayRef?.hasAttached() && this._popoverRef) {
      this._overlayPlacement.updatePosition(this._overlayRef, this.placement, this.alignment, this.offset);
      this._overlayRef.updatePosition();
    }
    if (('maxWidth' in changes || 'uxaTooltipMaxWidth' in changes) && this._popoverRef) {
      this._popoverRef.instance.maxWidth = this.maxWidth;
    }
  }
  /** Recalculate the position of the tooltip */
  updatePosition() {
    if (this.open) {
      this._overlayRef?.updatePosition();
      this._popoverRef?.instance.setArrowPosition(this._elementRef.nativeElement);
    }
  }
  onKeydown(event) {
    if (event.key === 'Escape' && this.closeTriggers.includes('escape') && this.open) {
      this.close();
      // this is required because a popover may be used within a dialog, and we don't want the escape key to close the dialog
      // if the popover is open
      event.stopPropagation();
    }
  }
  onClick() {
    if (this.openTriggers.includes('click')) {
      this.open ? this.close() : this._show$.next();
    }
  }
  onMouseEnter() {
    if (!this.open && this.openTriggers.includes('mouseenter')) {
      this._show$.next();
    }
  }
  onMouseLeave() {
    this.close();
  }
  onFocus() {
    if (!this.open && this.openTriggers.includes('focus')) {
      this._show$.next();
    }
  }
  onBlur() {
    if (this.closeTriggers.includes('blur')) {
      this.close();
    }
  }
  show() {
    if (this._overlayRef?.hasAttached() || this.disabled) {
      return;
    }
    // if content is empty, don't show it
    if (this.content === undefined || this.content === null || this.content === '') {
      return;
    }
    const overlayRef = this.getOverlay();
    const popover = this.getComponentPortal();
    const content = this.getContent();
    this._popoverRef = overlayRef.attach(popover);
    this._popoverRef.instance.content = content;
    this._popoverRef.instance.role = this.role;
    this._popoverRef.instance.id = this.id;
    this._popoverRef.instance.variant = this.variant;
    this._popoverRef.instance.alignment = this.alignment;
    this._popoverRef.instance.maxWidth = this.maxWidth;
    this._popoverRef.changeDetectorRef.detectChanges();
    this.open = true;
    this.openChange.emit(this.open);
    // if there is an existing trigger observer, disconnect it
    this._triggerObserver?.disconnect();
    if (isPlatformBrowser(this._platform)) {
      // create a mutation observer to detect when the trigger element is removed from the DOM.
      // we can't watch directly on the triggers parent as it is not guaranteed to be rendered in
      // in the DOM, for example if the trigger is an option in a select. Instead
      // we watch the body and check if the trigger element is still present. We disconnect the observer
      // when the popover is closed so this is not intensive watching all child mutations on the body, it is only
      // watching when the popover is open until it is closed.
      //
      // we also run this outside of angular to avoid triggering change detection on every mutation
      // which may cause dom updates - which in turn triggers the mutation observer again causing an infinite loop.
      this._zone.runOutsideAngular(() => {
        this._triggerObserver = new MutationObserver(() => {
          if (!this._document.body.contains(this._elementRef.nativeElement)) {
            this.close();
          }
        });
        this._triggerObserver.observe(this._document.body, {
          childList: true,
          subtree: true
        });
      });
      // add a resize observer so we can update the position of the popover when the tooltip changes size
      fromResizeObserver(this._elementRef.nativeElement, {
        injector: this._injector
      }).pipe(filter(() => this._listenForResize), takeUntilDestroyed(this._destroyRef)).subscribe(() => {
        this.updatePosition();
      });
    }
    combineLatest([this._isMouseInside$, this._popoverRef.instance.isMouseInside$]).pipe(debounceTime(100), filter(([isInside, isInsidePopover]) => this.closeTriggers.includes('mouseoutside') && !isInside && !isInsidePopover), takeUntil(this._didClose$), takeUntilDestroyed(this._destroyRef)).subscribe(() => {
      this.onMouseLeave();
    });
  }
  close() {
    // if there is an existing trigger observer, disconnect it
    this._triggerObserver?.disconnect();
    this._didClose$.next();
    if (!this._overlayRef) {
      return;
    }
    this._overlayRef?.detach();
    this.open = false;
    this.openChange.emit(this.open);
  }
  getOverlay() {
    const positionStrategy = this._overlay.position().flexibleConnectedTo(this._elementRef).withFlexibleDimensions(false).withPush(false);
    this._overlayRef = this._overlay.create({
      positionStrategy,
      direction: this._directionality.dir,
      scrollStrategy: this._overlay.scrollStrategies.reposition({
        scrollThrottle: 0
      }),
      hasBackdrop: this.closeTriggers.includes('clickoutside'),
      backdropClass: 'cdk-overlay-transparent-backdrop'
    });
    this._overlayPlacement.updatePosition(this._overlayRef, this.placement, this.alignment, this.offset);
    this._overlayRef.backdropClick().pipe(takeUntilDestroyed(this._destroyRef)).subscribe(() => this.close());
    positionStrategy.positionChanges.pipe(takeUntilDestroyed(this._destroyRef)).subscribe(change => {
      const currentPosition = change.connectionPair;
      // prevent infinite loop of recalculating position
      this._listenForResize = false;
      this.setPopoverPositionClass(currentPosition);
      this._popoverRef?.instance.setArrowPosition(this._elementRef.nativeElement);
      this._listenForResize = true;
    });
    return this._overlayRef;
  }
  getContent() {
    if (this.content instanceof TemplateRef) {
      return new TemplatePortal(this.content, this._viewContainerRef);
    }
    return this.content ?? '';
  }
  getComponentPortal() {
    return new ComponentPortal(UxaPopoverComponent, this._viewContainerRef);
  }
  setPopoverPositionClass(position) {
    if (position.originX === position.overlayX) {
      this.setVerticalPlacement(position);
    } else if (position.originY === position.overlayY) {
      this.setHorizontalPlacement(position);
    }
  }
  setVerticalPlacement(position) {
    if (this._popoverRef) {
      this._popoverRef.instance.placement = position.originY === 'top' ? 'above' : 'below';
    }
  }
  setHorizontalPlacement(position) {
    if (this._popoverRef) {
      this._popoverRef.instance.placement = position.originX === 'start' ? 'before' : 'after';
    }
  }
  /**
   * @internal
   */
  updateContent() {
    if (this._popoverRef) {
      this._popoverRef.instance.content = this.getContent();
      this._popoverRef.changeDetectorRef.markForCheck();
    }
  }
  static {
    this.ɵfac = function UxaPopoverDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UxaPopoverDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: UxaPopoverDirective,
      selectors: [["", "uxaPopover", ""]],
      hostVars: 1,
      hostBindings: function UxaPopoverDirective_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown", function UxaPopoverDirective_keydown_HostBindingHandler($event) {
            return ctx.onKeydown($event);
          });
        }
        if (rf & 2) {
          i0.ɵɵattribute("aria-describedby", ctx.open ? ctx.id : null);
        }
      },
      inputs: {
        id: [0, "uxaPopoverId", "id"],
        content: [0, "uxaPopover", "content"],
        open: [2, "uxaPopoverOpen", "open", booleanAttribute],
        disabled: [2, "uxaPopoverDisabled", "disabled", booleanAttribute],
        role: [0, "uxaPopoverRole", "role"],
        variant: [0, "uxaPopoverVariant", "variant"],
        placement: [0, "uxaPopoverPlacement", "placement"],
        alignment: [0, "uxaPopoverAlignment", "alignment"],
        maxWidth: [2, "uxaPopoverMaxWidth", "maxWidth", coerceCssPixelValue],
        openTriggers: [2, "uxaPopoverOpenTriggers", "openTriggers", coerceStringArray],
        closeTriggers: [2, "uxaPopoverCloseTriggers", "closeTriggers", coerceStringArray],
        offset: [2, "uxaPopoverOffset", "offset", numberAttribute],
        delay: [2, "uxaPopoverDelay", "delay", numberAttribute]
      },
      outputs: {
        openChange: "uxaPopoverOpenChange"
      },
      exportAs: ["uxaPopover"],
      features: [i0.ɵɵNgOnChangesFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UxaPopoverDirective, [{
    type: Directive,
    args: [{
      standalone: true,
      selector: '[uxaPopover]',
      outputs: ['openChange: uxaPopoverOpenChange'],
      exportAs: 'uxaPopover',
      host: {
        '[attr.aria-describedby]': 'open ? id : null'
      }
    }]
  }], null, {
    id: [{
      type: Input,
      args: ['uxaPopoverId']
    }],
    content: [{
      type: Input,
      args: ['uxaPopover']
    }],
    open: [{
      type: Input,
      args: [{
        alias: 'uxaPopoverOpen',
        transform: booleanAttribute
      }]
    }],
    disabled: [{
      type: Input,
      args: [{
        alias: 'uxaPopoverDisabled',
        transform: booleanAttribute
      }]
    }],
    role: [{
      type: Input,
      args: ['uxaPopoverRole']
    }],
    variant: [{
      type: Input,
      args: ['uxaPopoverVariant']
    }],
    placement: [{
      type: Input,
      args: ['uxaPopoverPlacement']
    }],
    alignment: [{
      type: Input,
      args: ['uxaPopoverAlignment']
    }],
    maxWidth: [{
      type: Input,
      args: [{
        alias: 'uxaPopoverMaxWidth',
        transform: coerceCssPixelValue
      }]
    }],
    openTriggers: [{
      type: Input,
      args: [{
        alias: 'uxaPopoverOpenTriggers',
        transform: coerceStringArray
      }]
    }],
    closeTriggers: [{
      type: Input,
      args: [{
        alias: 'uxaPopoverCloseTriggers',
        transform: coerceStringArray
      }]
    }],
    offset: [{
      type: Input,
      args: [{
        alias: 'uxaPopoverOffset',
        transform: numberAttribute
      }]
    }],
    delay: [{
      type: Input,
      args: [{
        alias: 'uxaPopoverDelay',
        transform: numberAttribute
      }]
    }],
    onKeydown: [{
      type: HostListener,
      args: ['keydown', ['$event']]
    }]
  });
})();
let uniqueId$1 = 0;
class UxaFlyoutDirective extends UxaPopoverDirective {
  constructor() {
    super();
    this.config = injectFlyoutConfig();
    this.id = `uxa-flyout-${uniqueId$1++}`;
    this.openTriggers = ['click'];
    this.closeTriggers = ['clickoutside', 'escape'];
    // set the global config defaults
    this.variant = this.config.variant;
    this.placement = this.config.placement;
    this.alignment = 'center';
    this.maxWidth = coerceCssPixelValue(this.config.maxWidth);
  }
  getComponentPortal() {
    return new ComponentPortal(UxaFlyoutComponent, this._viewContainerRef);
  }
  static {
    this.ɵfac = function UxaFlyoutDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UxaFlyoutDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: UxaFlyoutDirective,
      selectors: [["", "uxaFlyout", ""]],
      inputs: {
        content: [0, "uxaFlyout", "content"],
        open: [0, "uxaFlyoutOpen", "open"],
        disabled: [0, "uxaFlyoutDisabled", "disabled"],
        role: [0, "uxaFlyoutRole", "role"],
        variant: [0, "uxaFlyoutVariant", "variant"],
        placement: [0, "uxaFlyoutPlacement", "placement"],
        openTriggers: [0, "uxaFlyoutOpenTriggers", "openTriggers"],
        closeTriggers: [0, "uxaFlyoutCloseTriggers", "closeTriggers"],
        offset: [0, "uxaFlyoutOffset", "offset"],
        delay: [0, "uxaFlyoutDelay", "delay"],
        maxWidth: [0, "uxaFlyoutMaxWidth", "maxWidth"],
        id: [0, "uxaFlyoutId", "id"]
      },
      outputs: {
        openChange: "uxaFlyoutOpenChange"
      },
      exportAs: ["uxaFlyout"],
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UxaFlyoutDirective, [{
    type: Directive,
    args: [{
      standalone: true,
      selector: '[uxaFlyout]',
      inputs: ['content: uxaFlyout', 'open: uxaFlyoutOpen', 'disabled: uxaFlyoutDisabled', 'role: uxaFlyoutRole', 'variant: uxaFlyoutVariant', 'placement: uxaFlyoutPlacement', 'openTriggers: uxaFlyoutOpenTriggers', 'closeTriggers: uxaFlyoutCloseTriggers', 'offset: uxaFlyoutOffset', 'delay: uxaFlyoutDelay', 'maxWidth: uxaFlyoutMaxWidth'],
      outputs: ['openChange: uxaFlyoutOpenChange'],
      exportAs: 'uxaFlyout'
    }]
  }], () => [], {
    id: [{
      type: Input,
      args: ['uxaFlyoutId']
    }]
  });
})();
let uniqueId = 0;
class UxaTooltipDirective extends UxaPopoverDirective {
  constructor() {
    super();
    this.config = injectTooltipConfig();
    this.id = `uxa-tooltip-${uniqueId++}`;
    this.openTriggers = ['mouseenter', 'focus'];
    this.closeTriggers = ['mouseleave', 'blur'];
    // set the global config defaults
    this.variant = this.config.variant;
    this.placement = this.config.placement;
    this.alignment = this.config.alignment;
    this.maxWidth = coerceCssPixelValue(this.config.maxWidth);
  }
  getComponentPortal() {
    return new ComponentPortal(UxaTooltipComponent, this._viewContainerRef);
  }
  static {
    this.ɵfac = function UxaTooltipDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UxaTooltipDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: UxaTooltipDirective,
      selectors: [["", "uxaTooltip", ""]],
      inputs: {
        content: [0, "uxaTooltip", "content"],
        open: [0, "uxaTooltipOpen", "open"],
        disabled: [0, "uxaTooltipDisabled", "disabled"],
        role: [0, "uxaTooltipRole", "role"],
        variant: [0, "uxaTooltipVariant", "variant"],
        placement: [0, "uxaTooltipPlacement", "placement"],
        alignment: [0, "uxaTooltipAlignment", "alignment"],
        openTriggers: [0, "uxaTooltipOpenTriggers", "openTriggers"],
        closeTriggers: [0, "uxaTooltipCloseTriggers", "closeTriggers"],
        offset: [0, "uxaTooltipOffset", "offset"],
        delay: [0, "uxaTooltipDelay", "delay"],
        maxWidth: [0, "uxaTooltipMaxWidth", "maxWidth"],
        id: [0, "uxaTooltipId", "id"]
      },
      outputs: {
        openChange: "uxaTooltipOpenChange"
      },
      exportAs: ["uxaTooltip"],
      features: [i0.ɵɵInheritDefinitionFeature]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UxaTooltipDirective, [{
    type: Directive,
    args: [{
      standalone: true,
      selector: '[uxaTooltip]',
      inputs: ['content: uxaTooltip', 'open: uxaTooltipOpen', 'disabled: uxaTooltipDisabled', 'role: uxaTooltipRole', 'variant: uxaTooltipVariant', 'placement: uxaTooltipPlacement', 'alignment: uxaTooltipAlignment', 'openTriggers: uxaTooltipOpenTriggers', 'closeTriggers: uxaTooltipCloseTriggers', 'offset: uxaTooltipOffset', 'delay: uxaTooltipDelay', 'maxWidth: uxaTooltipMaxWidth'],
      outputs: ['openChange: uxaTooltipOpenChange'],
      exportAs: 'uxaTooltip'
    }]
  }], () => [], {
    id: [{
      type: Input,
      args: ['uxaTooltipId']
    }]
  });
})();
class UxaPopoverOverlayContainer extends OverlayContainer {
  constructor() {
    super(inject(DOCUMENT), inject(Platform));
  }
  _createContainer() {
    super._createContainer();
    // the UX Aspects modal has a z-index of 9998, so we need to make sure the overlay container is above that
    // so that any tooltips or popovers will be visible.
    // This cannot be achieved using CSS as the overlay container is appended to the body and not a child of the
    // component that is using it and we also don't want to change the z-index of all overlays, just popovers and tooltips
    this._containerElement.style.zIndex = '9999';
  }
  static {
    this.ɵfac = function UxaPopoverOverlayContainer_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UxaPopoverOverlayContainer)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: UxaPopoverOverlayContainer,
      factory: UxaPopoverOverlayContainer.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UxaPopoverOverlayContainer, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();
class UxaPopoverModule {
  static {
    this.ɵfac = function UxaPopoverModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || UxaPopoverModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: UxaPopoverModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: OverlayContainer,
        useClass: UxaPopoverOverlayContainer
      }],
      imports: [CommonModule, OverlayModule, PortalModule, UxaThemeModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(UxaPopoverModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, OverlayModule, PortalModule, UxaThemeModule, UxaPopoverDirective, UxaTooltipDirective, UxaFlyoutDirective, UxaPopoverComponent, UxaTooltipComponent, UxaFlyoutComponent],
      exports: [UxaPopoverDirective, UxaTooltipDirective, UxaFlyoutDirective],
      providers: [{
        provide: OverlayContainer,
        useClass: UxaPopoverOverlayContainer
      }]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { OverlayPlacement, UxaFlyoutComponent, UxaFlyoutDirective, UxaPopoverComponent, UxaPopoverDirective, UxaPopoverModule, UxaTooltipComponent, UxaTooltipDirective, provideFlyoutConfig, providePopoverConfig, provideTooltipConfig };
